<!-- eslint-disable max-len -->
<template>
  <div id="app">
    <div id="thesafe"></div>
    <HelloWorld/>
  </div>
</template>

<script>
import Vivus from 'vivus';
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',
  // eslint-disable-next-line
  mounted: function () {
    // eslint-disable-next-line
    new Vivus('thesafe', { 
      duration: 200,
      file: './static/logo.svg',
    }, (el) => {
      // eslint-disable-next-line
      el.map.forEach(element => {
        const style = getComputedStyle(element.el);
        // eslint-disable-next-line
        element.el.style.fill = style.stroke;
        // eslint-disable-next-line
        element.el.style.stroke = 'none';
      });
    });
  },
  components: {
    HelloWorld,
  },
  head: {
    script: [
      { t: 'text/javascript', src: 'https://www.gstatic.com/firebasejs/7.14.0/firebase-app.js' },
      { t: 'text/javascript', src: 'https://www.gstatic.com/firebasejs/7.14.0/firebase-analytics.js' },
      { t: 'text/javascript', src: 'https://www.gstatic.com/firebasejs/7.14.0/firebase-auth.js' },
      { t: 'text/javascript', src: 'https://www.gstatic.com/firebasejs/7.14.0/firebase-firestore.js' },
    ],
  },
};
</script>

<style>

svg path{
  transition: fill 2s ease-in-out;
}
#thesafe{
    max-width: 320px;
    max-height: 300px;
    margin:auto;
    display: block;
}
#app {
    direction: rtl;
  background-color: #FABEBD;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: calc(100vh - 16px);
}
*{
    direction: rtl;
}
</style>



// WEBPACK FOOTER //
// src/App.vue